// extracted by mini-css-extract-plugin
export default {"ctaInvisible":"SectionHero_ctaInvisible__-2QvT","root":"SectionHero_root__dQLse","consultantBg":"SectionHero_consultantBg__yQNfH","clientBg":"SectionHero_clientBg__NPxdl"};